export default "__VITE_ASSET__DEO4fZej__"